import { getAuth, signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from 'firebase/auth';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import UserRoles from '../../../resources/enums/UserRoles';
import { User } from '../types';
import DbCollections from '../../../resources/enums/DbCollections';

const getUserData = async (uid: string) => {
    const docRef = doc(getFirestore(), DbCollections.Users, uid);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) return undefined;
    const user = docSnap.data();
    return {
        uid: uid,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        roles: user.role,
        contactTypes: user.contactTypes,
    };
};

export const signOutFirebase = () => {
    const auth = getAuth();
    signOut(auth);
};

export const signInWithEmailPasswordFirebase = async (email: string, password: string) => {
    const auth = getAuth();
    return signInWithEmailAndPassword(auth, email, password)
        .then(async (user) => {
            const userData = (await getUserData(user.user.uid)) as User;
            const isAdmin = userData.roles.some((r) =>
                ([UserRoles.Admin, UserRoles.SuperAdmin, UserRoles.Coach] as string[]).includes(r),
            );
            if (!isAdmin) return undefined;
            return userData;
        })
        .catch((err) => {
            throw new Error(err);
        });
};

export const resetPasswordFirebase = (email: string) => {
    const auth = getAuth();
    sendPasswordResetEmail(auth, email)
        .then(() => {
            return true;
        })
        .catch((error) => {
            throw new Error(error);
        });
};
